<script lang="ts">
  import type { ContainerProps } from '$lib/types/components';
  import { twMerge } from 'tailwind-merge';

  type $$Props = ContainerProps;

  export let size: $$Props['size'] = 'default';
  export let tag: $$Props['tag'] = 'div';

  const { class: propsClass } = $$props as $$Props;
</script>

<svelte:element
  this={tag}
  class={twMerge(
    'mx-auto px-6 md:max-w-4xl md:px-12 lg:max-w-none lg:px-16',
    size === 'default' && 'xl:max-w-6xl xl:px-4',
    size === 'wide' && 'xl:max-w-7xl xl:px-5',
    propsClass
  )}
>
  <slot />
</svelte:element>

<!--
@component
Wrapper component to set consistent max-width and outer x-padding on content.
## Props
@prop size: 'default' | 'wide' = 'default';
@prop tag: string = 'div';
-->
